import {
    CreditCardIcon,
    FileTextIcon,
    GaugeIcon,
    PackageIcon,
} from "lucide-react"
import { NavigationMenu } from "./models"

const defaultResolutionCenterUrl = "https://portal.100581.cloudfit.software/resolutioncenter"

export function buildNavigationMenu(_resolutionCenterUrl = defaultResolutionCenterUrl): NavigationMenu {
    return {
        sections: [
            {
                displayName: "Get Started",
                items: [
                    {
                        displayName: "Dashboard",
                        type: "internal",
                        page: "Dashboard",
                        icon: GaugeIcon,
                    },
                ],
            },
            {
                displayName: "Billing",
                items: [
                    {
                        displayName: "Subscriptions",
                        type: "internal",
                        page: "Subscriptions",
                        icon: PackageIcon,
                    },
                    {
                        displayName: "Invoices",
                        type: "internal",
                        page: "Invoices",
                        icon: FileTextIcon,
                    },
                    {
                        displayName: "Payment Methods",
                        type: "internal",
                        page: "PaymentMethods",
                        icon: CreditCardIcon,
                    },
                ],
            },
            // TODO: Bring this back when ready to expose resolution center to users.
            // {
            //     displayName: "Support",
            //     items: [
            //         {
            //             displayName: "Resolution Center",
            //             type: "external",
            //             href: _resolutionCenterUrl,
            //             icon: WrenchIcon,
            //             openInNewTab: true,
            //         },
            //     ],
            // },
        ],
    }
}

export const navigationMenu = buildNavigationMenu()
